import { useContext } from 'react';

import { TrackHeightContext } from '../contexts/TrackHeight';

export function useTrackHeight() {
  return useContext(TrackHeightContext);
}
